import { useTranslation } from 'react-i18next'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import {
  StyledActions,
  StyledBadge,
  StyledCardHeader,
  StyledCardTitle,
  StyledCodeCard,
  StyledInfo,
  StyledScript,
} from './styled-components'

const MODULE = 'subscriptionForm:fidelity_maximizer_module'

interface LegacyPathButtonProps {
  label: string
  disabled: boolean
  loading: boolean
  onClick: () => void
}

const LegacyPathButton = ({ label, disabled, loading, onClick }: LegacyPathButtonProps) => (
  /* @ts-ignore */
  <SDButton block={true} disabled={disabled} isLoading={loading} onClick={onClick}>
    {label}
  </SDButton>
)

interface LegacyPathCardProps {
  hidden: boolean
  copyKey: string
  demoted: boolean
  disabled: boolean
  loading: boolean
  onClick: () => void
}

const LegacyPathCard = ({ hidden, copyKey, demoted, disabled, loading, onClick }: LegacyPathCardProps) => {
  const { t } = useTranslation()

  if (hidden) {
    return null
  }

  const cta = t(`${MODULE}.${copyKey}.cta`)

  if (!demoted) {
    return (
      <>
        <SDNotification
          type='info'
          border
          primaryText={`<strong>${t(`${MODULE}.${copyKey}.card_title`)}</strong><br />${t(
            `${MODULE}.${copyKey}.script`,
          )}`}
        >
          <LegacyPathButton label={cta} disabled={disabled} loading={loading} onClick={onClick} />
        </SDNotification>
        <StyledInfo>{t(`${MODULE}.${copyKey}.info`)}</StyledInfo>
      </>
    )
  }

  return (
    <StyledCodeCard $muted>
      <StyledCardHeader>
        <StyledCardTitle>{t(`${MODULE}.legacy_path.card_title`)}</StyledCardTitle>
        <StyledBadge $muted>{t(`${MODULE}.legacy_path.badge`)}</StyledBadge>
      </StyledCardHeader>
      <StyledScript>{t(`${MODULE}.${copyKey}.script`)}</StyledScript>
      <StyledActions>
        <LegacyPathButton label={cta} disabled={disabled} loading={loading} onClick={onClick} />
      </StyledActions>
      <StyledInfo>{t(`${MODULE}.${copyKey}.info`)}</StyledInfo>
    </StyledCodeCard>
  )
}

export default LegacyPathCard
